import React from 'react';
import { Link } from 'react-router-dom';

const currentYear = new Date().getFullYear();

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white mt-auto border-t border-gray-800">
      
      {/* --- MOBILE COMPACT VIEW --- */}
      <div className="md:hidden py-6 px-4 flex flex-col items-center gap-4 text-center">
        <div className="flex items-center gap-2">
          <img src="/ruchira-logo.png" alt="Ruchira" className="h-6 w-auto grayscale brightness-200" />
          <span className="text-lg font-bold tracking-tight text-orange-500">RUCHIRA</span>
        </div>
        <div className="flex flex-wrap gap-4 text-xs text-gray-400 font-medium justify-center">
          <Link to="/" className="hover:text-white">Home</Link>
          <Link to="/subscription" className="hover:text-white">Plans</Link>
          <Link to="/orders" className="hover:text-white">Orders</Link>
          <Link to="/profile" className="hover:text-white">Profile</Link>
        </div>
        <div className="flex flex-wrap gap-3 text-[10px] text-gray-500 font-medium justify-center">
          <Link to="/privacy" className="hover:text-orange-400">Privacy</Link>
          <Link to="/terms" className="hover:text-orange-400">Terms</Link>
          <a href="mailto:pgppioneers@gmail.com" className="hover:text-orange-400">Contact</a>
        </div>
        <div className="text-[10px] text-gray-600 flex flex-col gap-1">
          <p>&copy; {currentYear} Ruchira</p>
          <p>
            Made with ❤️ by{' '}
            <a href="https://xarv.in" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-400 font-medium">
              Xarvin
            </a>
          </p>
        </div>
      </div>

      {/* --- DESKTOP FULL VIEW --- */}
      <div className="hidden md:block py-12 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          
          {/* Brand Section */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img src="/ruchira-logo.png" alt="Ruchira" className="h-10 w-auto grayscale brightness-200 rounded-full shadow-lg" />
              <div>
                <h2 className="text-2xl font-bold tracking-tight text-orange-500">RUCHIRA</h2>
                <p className="text-gray-400 text-sm">Authentic home food, delivered with love.</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              Connecting you with authentic home-cooked meals from local chefs, delivered fresh to your doorstep.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-gray-200 mb-6 uppercase tracking-wider text-orange-400">Discover</h3>
            <ul className="space-y-3 text-sm text-gray-300">
              <li><Link to="/" className="hover:text-orange-400 transition-colors block py-1">Home</Link></li>
              <li><Link to="/subscription" className="hover:text-orange-400 transition-colors block py-1">Meal Plans</Link></li>
              <li><Link to="/kitchen" className="hover:text-orange-400 transition-colors block py-1">All Kitchens</Link></li>
              <li><Link to="/chef/dashboard" className="hover:text-orange-400 transition-colors block py-1">For Chefs</Link></li>
              <li><Link to="/kitchen/dashboard" className="hover:text-orange-400 transition-colors block py-1">For kitchens</Link></li>
            </ul>
          </div>

          {/* Support & Legal */}
          <div>
            <h3 className="text-lg font-semibold text-gray-200 mb-6 uppercase tracking-wider text-orange-400">Support</h3>
            <ul className="space-y-3 text-sm text-gray-300">
              <li><Link to="/orders" className="hover:text-orange-400 transition-colors block py-1">My Orders</Link></li>
              <li><Link to="/profile" className="hover:text-orange-400 transition-colors block py-1">Account</Link></li>
              <li><a href="mailto:pgppioneers@gmail.com" className="hover:text-orange-400 transition-colors block py-1">Contact Us</a></li>
            </ul>
          </div>
        </div>

        {/* Legal Footer Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-gray-500">
            {/* Copyright & Xarvin */}
            <div className="flex items-center gap-4 order-3 md:order-1">
              <span>&copy; {currentYear} Ruchira. All rights reserved.</span>
              <span className="hidden md:block">|</span>
              <span>
                Made with ❤️ by{' '}
                <a href="https://xarv.in" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-400 font-medium">
                  Xarvin
                </a>
              </span>
            </div>
            
            {/* Legal Links - Prominent */}
            <div className="flex gap-6 order-1 md:order-2 font-medium">
              <Link to="/privacy" className="hover:text-orange-400 transition-colors border-r border-gray-700 pr-6 py-1">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-orange-400 transition-colors border-r border-gray-700 pr-6 py-1">Terms of Service</Link>
              <a href="mailto:pgppioneers@gmail.com" className="hover:text-orange-400 transition-colors py-1">Contact Us</a>
            </div>
            
            {/* Payments & Delivery */}
            <div className="flex gap-6 order-2 md:order-3 text-gray-500">
              <span>Payments: Razorpay | UPI</span>
              <span>Delivery: Local Partners</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
